export const isExternalUrl = (href = ''): boolean => {
  try {
    new URL(href);
    return true;
  } catch (error) {
    return false;
  }
};
